import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { Category } from '@shared/schemas';

// Shared categories query + id→category lookup. Used by the home, favourites
// and recipe detail so the map isn't rebuilt by hand in each.
export function useCategoryMap() {
  const { data } = useQuery({ queryKey: ['categories'], queryFn: api.listCategories });
  const categories = data ?? [];
  const byId = useMemo(() => {
    const map = new Map<number, Category>();
    for (const c of categories) map.set(c.id, c);
    return map;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  return { categories, byId };
}
